import React from 'react';
import PropTypes from 'prop-types';

import { buildDescription } from 'components/IndividualValidationResult';
import FormTypes from 'common/Forms/FormTypes';

const ValidationResultCell = ({ dataKey, data, className, isPiiProtectionEnabled, piiValidationCodes, formType }) => {
  const getItemClass = (item) => {
    if (item.code) {
      if (item.code.indexOf('WRN') !== -1) {
        return 'red-flag';
      }
      if (item.code.indexOf('REC') !== -1) {
        return 'recommendation';
      }
    }
    return '';
  };

  const isPiiValidationCode = (validationCode) => {
    const formTypeFamily = formType ? FormTypes[formType.toLowerCase()] : formType && FormTypes[formType.toLowerCase()];
    const family = (formTypeFamily && formTypeFamily.family) ? formTypeFamily.family.toUpperCase() : false;

    let result;

    if (validationCode && validationCode.indexOf('REC') !== -1) {
      const numericCode = validationCode.replace('REC', '');

      const rejectionsAndWarnings = [...data.warnings, ...data.rejections].filter(v => v.code.indexOf('REC') === -1 && v.code.indexOf(numericCode) !== -1);

      result = rejectionsAndWarnings
        && rejectionsAndWarnings.filter(v => isPiiValidationCode(v && v.code) === true).length !== 0;
      return result;
    }

    result = family && piiValidationCodes && piiValidationCodes[family]
      && piiValidationCodes[family].filter(code => code.substring(4) === validationCode.substring(3)).length !== 0;
    return result;
  };

  return (<div className={ className }>
    { data != null && data[dataKey] != null && data[dataKey].length === 0 && <span>N/A</span> }
    { data[dataKey] != null && data[dataKey].length !== 0 && <ul>
      { data[dataKey].sort(({ code: a }, { code: b }) => {
        if (a.indexOf('WRN') === 0 && b.indexOf('REC') === 0) {
          return -1;
        }
        if (b.indexOf('WRN') === 0 && a.indexOf('REC') === 0) {
          return 1;
        }
        return 0;
      }).map(item => (item != null && !isPiiValidationCode(item.code)
        && <li
          key={ item.key }
          className={ getItemClass(item) }
        >
          { buildDescription(item) }
          &nbsp;({ item.code })</li>
      ))}
      {(isPiiProtectionEnabled === true && data[dataKey].filter(item => item.code.indexOf('REC') === -1 && isPiiValidationCode(item.code)).length > 0)
      && <p><strong>Personally Identifiable Information (PII) {dataKey === 'rejections' ? 'Rejections' : 'Warnings' }:</strong></p>}
      {isPiiProtectionEnabled === true
        && data[dataKey].sort(({ code: a }, { code: b }) => {
          if (a.indexOf('WRN') === 0 && b.indexOf('REC') === 0) {
            return -1;
          }
          if (b.indexOf('WRN') === 0 && a.indexOf('REC') === 0) {
            return 1;
          }
          return 0;
        }).map(item => (item != null && (isPiiValidationCode(item.code) && item.code.indexOf('REC') === -1)
          && <li
            key={ item.key }
            className={ getItemClass(item) }
          >
            {buildDescription(item)}
            &nbsp;({item.code})</li>
        ))}
    </ul> }
  </div>);
};

ValidationResultCell.propTypes = {
  dataKey: PropTypes.string,
  data: PropTypes.shape(),
  className: PropTypes.string,
  isPiiProtectionEnabled: PropTypes.bool,
  piiValidationCodes: PropTypes.shape(),
  formType: PropTypes.string
};

ValidationResultCell.defaultProps = {
  dataKey: null,
  data: null,
  className: null,
  isPiiProtectionEnabled: false,
  piiValidationCodes: null,
  formType: null
};

export default ValidationResultCell;
